"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const room_1 = require("../../../model/room");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const form_for_1 = require("../../../widgets/form_for");
const right_panel_1 = require("../../../widgets/right_panel");
const table_1 = require("../../../widgets/table");
const room_form_1 = require("./room_form");
exports.RoomTable = (0, table_1.createTable)({
    id: "roomTable",
    filters: [],
    provider: room_1.RoomProvider,
    title: "Salles",
    topMenuRight: () => {
        return [
            (0, mithril_1.default)("a", { class: "button is-success with-margin", onclick: () => {
                    room_form_1.RoomForm.show();
                } }, (0, helpers_1.iconSpan)("fa-user-plus", "is-small"), (0, mithril_1.default)("span", "Nouvelle Salle"))
        ];
    },
    fields: [
        {
            name: "id",
            sortable: true,
            label: "n°"
        },
        {
            name: "name",
            sortable: true,
            label: "Nom"
        },
        {
            name: "venue.name",
            sortable: true,
            label: "Centre opérationnel",
            renderer: table_renderers_1.TableRenderers.resourceLink("venues", "show", (mdl) => mdl["venue_id"], (mdl) => mdl["venue.name"])
        },
        {
            name: "active",
            sortable: true,
            label: "Actif",
            renderer: (x, value) => { return table_renderers_1.TableRenderers.bool(x, value); }
        },
        {
            name: "available_hardware",
            sortable: false,
            label: "Matériel",
            renderer: (_x, value) => { return value && value.length > 0 ? (0, helpers_1.tags)(value.sort(), 'primary') : (0, helpers_1.empty)(); }
        },
        {
            name: "created_at",
            sortable: true,
            label: "Créé le",
            renderer: table_renderers_1.TableRenderers.date
        }
    ],
    actions: (obj) => {
        return (0, form_for_1.gaplessColumns)((0, mithril_1.default)("a", {
            class: "button",
            onclick: () => { right_panel_1.RightPanel.open("rooms", obj.id, "show"); }
        }, (0, helpers_1.iconSpan)("fa-eye")), (0, mithril_1.default)("a", {
            class: "button",
            onclick: () => { room_form_1.RoomForm.show(obj); },
        }, (0, helpers_1.iconSpan)("fa-pen")));
    }
});
